import React from 'react';
import { DomainEntry } from '../../hooks/useBrainPocket';

type SidebarProps = {
  search: string;
  setSearch: (value: string) => void;
  filteredDomains: DomainEntry[];
  domainOpen: Record<string, boolean>;
  setDomainOpen: React.Dispatch<React.SetStateAction<Record<string, boolean>>>;
  selectedArticleId: string | null;
  setSelectedArticleId: (articleId: string) => void;
};

export default function Sidebar({
  search,
  setSearch,
  filteredDomains,
  domainOpen,
  setDomainOpen,
  selectedArticleId,
  setSelectedArticleId,
}: SidebarProps) {
  return (
    <aside className="brainpocket-sidebar" aria-label="Knowledge tree">
      <label className="brainpocket-search">
        <span>Search tree</span>
        <input
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Domain, article, URL, or key point"
        />
      </label>

      <div className="brainpocket-tree">
        {filteredDomains.length === 0 ? (
          <p className="brainpocket-empty-note">No matching nodes yet.</p>
        ) : filteredDomains.map(([domain, data]) => {
          const open = search.trim().length > 0 || !!domainOpen[domain];
          return (
            <div key={domain} className="brainpocket-domain-node">
              <button
                type="button"
                onClick={() => setDomainOpen((previous) => ({ ...previous, [domain]: !open }))}
                className="brainpocket-domain-toggle"
                aria-expanded={open}
              >
                <span>{domain}</span>
                <span className="brainpocket-node-count">{data.articles.length}</span>
              </button>

              {open && (
                <div className="brainpocket-article-list">
                  {data.articles.map((article) => (
                    <button
                      key={article.id}
                      type="button"
                      onClick={() => setSelectedArticleId(article.id)}
                      className={[
                        'brainpocket-article-node',
                        selectedArticleId === article.id ? 'is-selected' : '',
                        article.read ? 'is-read' : '',
                      ].filter(Boolean).join(' ')}
                    >
                      <span>{article.title}</span>
                      <small>{article.keyPoints.length} key points</small>
                    </button>
                  ))}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </aside>
  );
}
